import type { UiState } from './bridge';
export const observationSpeciesId = (value: string): string => value.toLowerCase().replace(/[\s_]+/g, '_');
/** Only current physical presence supplies start choices. Report history never does. */
export function observationSpeciesAt(sim: Pick<UiState, 'animals' | 'fieldCapture'>, site: string): string[] {
  const species = site === 'field' ? (sim.fieldCapture?.wildAnimals ?? []).map(a => a.species) : sim.animals.filter(a => a.enclosure === site).map(a => a.speciesId ?? a.species);
  return [...new Set(species.map(observationSpeciesId))].sort();
}
export function observationInitialSite(sim: Pick<UiState, 'animals' | 'enclosures'>, wanted?: string): string {
  if (!wanted) return 'field';
  const match = sim.animals.find(a => observationSpeciesId(a.speciesId ?? a.species) === observationSpeciesId(wanted) && a.enclosure !== null && sim.enclosures.some(e => e.id === a.enclosure));
  return match?.enclosure ?? 'field';
}
